import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import iconSrc from '../../../utils/iconSrc';
// Components
import Testimonial from '../testimonial/testimonial';
// Styles
import { VisuallyHidden } from '../../styled/accessibility';

import {
  ButtonSVG,
  ButtonWrapper,
  Button,
  SlideCarouselOuter,
  SlideCarouselInner,
  SlideMask,
} from './styles.js';

const QuoteSlider = ({ quotes = [], sidebar, contentfulId }) => {
  const [currentPosition, setCurrentPosition] = useState(0);
  const [isFirst, setIsfirst] = useState(true);
  const [isLast, setIsLast] = useState(false);

  const goToSlide = useCallback(
    (direction) => {
      const nextPosition = currentPosition + direction;
      setCurrentPosition(nextPosition);
      setIsfirst(nextPosition === 0);
      setIsLast(nextPosition === quotes.length - 1);
    },
    [currentPosition, quotes.length]
  );

  const generateArrows = (position) => {
    if (quotes.length > 1) {
      return (
        <ButtonWrapper>
          <Button
            id={`prev_${contentfulId}_${position}`}
            type="button"
            onClick={() => goToSlide(-1)}
            disabled={isFirst || position !== currentPosition}
          >
            <ButtonSVG
              src={iconSrc('chevron-left')}
              cacheRequests
              alt="Previous quote"
            />
            <VisuallyHidden>Previous quote</VisuallyHidden>
          </Button>
          <Button
            id={`next_${contentfulId}_${position}`}
            type="button"
            onClick={() => goToSlide(1)}
            disabled={isLast || position !== currentPosition}
          >
            <ButtonSVG
              src={iconSrc('chevron-right')}
              cacheRequests
              alt="Next quote"
            />
            <VisuallyHidden>Next quote</VisuallyHidden>
          </Button>
        </ButtonWrapper>
      );
    }
    return null;
  };

  const slider = { arrows: generateArrows, isSlider: true };

  if (quotes.length === 0) return null;

  return (
    <SlideCarouselOuter $numSlides={quotes.length} $current={currentPosition}>
      <SlideCarouselInner>
        <SlideMask sidebar={sidebar}>
          {quotes.map((quote, i) => (
            <Testimonial
              data={quote}
              isOdd={false}
              slider={slider}
              sidebar={sidebar}
              key={i}
              position={i}
            />
          ))}
        </SlideMask>
      </SlideCarouselInner>
    </SlideCarouselOuter>
  );
};

QuoteSlider.propTypes = {
  quotes: PropTypes.array,
  sidebar: PropTypes.bool,
  contentfulId: PropTypes.string.isRequired,
};

export default QuoteSlider;
